<template>
  <div id="faq-view">
    <section class="bg-light">
      <main>
        <article class="container py-5 faq-content">
          <h1>Frequently Asked Questions</h1>

          <section v-for="faq in faqs" :key="faq.question" class="faq-item">
            <h2>{{ faq.question }}</h2>
            <p>{{ faq.answer }}</p>
          </section>
        </article>
      </main>
    </section>
  </div>
</template>

<script>
const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "How is Govava different from a gift quiz or gift finder tool?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "Govava builds an ongoing personality and lifestyle profile of each recipient, including specialized profiling for pets, rather than relying on a one-time quiz or keyword filters. Recommendations improve as the platform learns more about the recipient over time.",
      },
    },
    {
      "@type": "Question",
      name: "How is Govava different from a chat-based gift finder?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "Rather than requiring the user to describe a recipient's personality in a text prompt, Govava applies structured psychological and lifestyle profiling automatically, reducing the effort needed from the person searching for a gift.",
      },
    },
    {
      "@type": "Question",
      name: "Does Govava work for corporate gifting, not just personal gifts?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "Yes. Govava applies the same personalization engine used for consumer gifting to corporate gifting and employee and client recognition programs, so B2B gifts are matched to individual recipients rather than selected from a generic bulk catalog.",
      },
    },
    {
      "@type": "Question",
      name: "What retailers can I buy from through Govava?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "Govava connects to over 3,000 retail stores through the Rakuten affiliate network, plus direct integrations with Amazon, Etsy, and Walmart.",
      },
    },
  ],
};

export default {
  name: "FAQView",
  metaInfo: {
    title: "Govava FAQ | Personal and Corporate Gift Recommendations",
    meta: [
      {
        name: "description",
        content:
          "Learn how Govava's personality and lifestyle profiling powers personalized gifts for individuals, pets, and corporate gifting programs.",
      },
    ],
    link: [{ rel: "canonical", href: "https://www.govava.com/faq" }],
    script: [
      {
        type: "application/ld+json",
        json: FAQ_SCHEMA,
      },
    ],
  },
  data() {
    return {
      faqs: FAQ_SCHEMA.mainEntity.map((item) => ({
        question: item.name,
        answer: item.acceptedAnswer.text,
      })),
    };
  },
};
</script>

<style scoped>
.faq-content {
  max-width: 900px;
  color: #2c3e50;
}

.faq-content > h1 {
  margin-bottom: 2rem;
}

.faq-item {
  margin-bottom: 2rem;
}

.faq-item h2 {
  font-size: 1.35rem;
  margin-bottom: 0.75rem;
}

.faq-item p {
  font-size: 1.05rem;
  line-height: 1.7;
}
</style>
